import Swal from 'sweetalert2';

export const toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 2600,
  timerProgressBar: true,
  customClass: {
    popup: 'app-toast',
    title: 'app-toast-title',
    timerProgressBar: 'app-toast-progress',
  },
  didOpen: (el) => {
    el.addEventListener('mouseenter', Swal.stopTimer);
    el.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

export const showToast = ({ icon = 'success', title, text }) =>
  toast.fire({ icon, title, text });

export const showConfirmDialog = ({
  title,
  text,
  html,
  icon = 'warning',
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  confirmButtonColor,
}) =>
  Swal.fire({
    title,
    text,
    html,
    icon,
    showCancelButton: true,
    reverseButtons: true,
    focusCancel: true,
    confirmButtonText,
    cancelButtonText,
    confirmButtonColor,
    customClass: {
      popup: 'app-modal',
      title: 'app-modal-title',
      htmlContainer: 'app-modal-body',
      confirmButton: 'app-modal-confirm',
      cancelButton: 'app-modal-cancel',
    },
    buttonsStyling: false,
  });

export const showAlert = ({ title, text, html, icon = 'info' }) =>
  Swal.fire({
    title,
    text,
    html,
    icon,
    customClass: {
      popup: 'app-modal',
      title: 'app-modal-title',
      htmlContainer: 'app-modal-body',
      confirmButton: 'app-modal-confirm',
    },
    buttonsStyling: false,
  });
